import React, { Component } from 'react';

/*
import {userDataFromGSNTV} from './../../../utils/gsntv';
*/

import './../../../../scss/App.scss';
import { trackingWrapper } from '../../../utils/analytics';


class InstructionsOverlay extends Component {
	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax({onComplete : this.handleTransitionComplete,
									onCompleteParams:[this],
									onReverseComplete:this.handleTransitionOutComplete, 
									onReverseCompleteParams:[this]});
	}

	componentDidMount(){

		// get users highest score if logged in (prep data)
		/*
		if(this.props.userLoggedIn){
			userDataFromGSNTV().then((data) => {
				console.log("InstructionsOverlay :: componentDidMount - userDataFromGSNTV data = ", data);
				window.userMaxScore = data.userMaxScore;
			});
		}
		*/

		// animate in

		window.TweenMax.set(this.refs.overlay, {"opacity": 0});
		window.TweenMax.set(this.refs.line1, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line2, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line3, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line4, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.thumbnail, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.playBtn, {"opacity": 0, "transform":"translateY(1vw)"});


		this.transitionIn.to(this.refs.overlay, .5, {"opacity":1, "delay":.3})
		.to(this.refs.line1, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line2, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line3, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line4, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.thumbnail, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.playBtn, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")

		//tracking
		trackingWrapper('event', 'ASgame-intro-screen', {'event_category':'america-says-game'});
	}

	handleTransitionComplete(_this){
	
	}

	handleTransitionOutComplete(_this){
		//this.props.initRound();
	}

	handlePlayBtnClick(){
		//this.transitionIn.reverse();
	}

	render(){
		return(
			<div className="instructions_overlay" ref="overlay">
				<div className="content" ref="content">
					<div className="text">
						<div className="firstLine" ref="line1">HOW TO PLAY</div>
						<ol>
							<li ref="line2">GUESS HOW AMERICA FILLED IN THE BLANKS</li>
							<li ref="line3">THE FIRST LETTER OF THE ANSWER WILL APPEAR</li>
							<li ref="line4">GUESS AS MANY AS YOU CAN IN {this.props.timer} SECONDS</li>
						</ol>
						<div className="thumbnail" ref="thumbnail"></div>
					</div>
					<div className="playBtn" ref="playBtn" onClick={() => this.props.initRound()} onMouseOver={() => window.sounds.buttonHover.play()}>START</div>
				</div>
			</div>
		);
	}
}

export default InstructionsOverlay;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/instructions/InstructionsOverlay.js